import { Button, RuleItem, SVG } from "ui";
import {
    CustomComponentProps,
    GeneralModalProps
} from "utils/types/generalTypes";

import incidentRules, { IncidentRule } from "assets/data/incidentsRules";
import { useEffect, useState } from "react";
export type RulesModelProps = GeneralModalProps & CustomComponentProps;

export type IncidentRulesOpen = IncidentRule & { isOpened: boolean };

const RulesModel = ({ open, setOpen, className, style }: RulesModelProps) => {
    const [rules, setRules] = useState<IncidentRulesOpen[]>([]);

    const setNRules = () => {
        const nRules: IncidentRulesOpen[] = incidentRules.map((i) => ({
            ...i,
            isOpened: false
        }));
        setRules(nRules);
    };

    useEffect(() => {
        setNRules();
    }, []);

    const openRule = (attr: IncidentRulesOpen) => {
        const nRules = rules.map((r) => {
            if (r.question == attr.question) {
                return { ...r, isOpened: true };
            } else {
                return { ...r, isOpened: false };
            }
        });
        setRules(nRules);
    };

    return (
        <div
            className={`incdident-rules-modal modal share-modal is-xsmall has-light-bg ${open ? "is-active" : ""} ${className}`}
            style={style}
        >
            <div className="modal-background"></div>
            <div className="modal-content">
                <div className="card">
                    <div className="card-heading flex-a-start">
                        <div>
                            <h3 className="fw-500"> Incident Rules </h3>
                        </div>

                        {/* <!-- Close X button --> */}
                        <div className="close-wrap">
                            <span
                                className="close-modal"
                                onClick={() => setOpen(false)}
                            >
                                <SVG
                                    svg="x"
                                    size={16}
                                    className="light-grey-svg"
                                />
                            </span>
                        </div>
                    </div>

                    <div className="card-body">
                        <div className="rules-desc momeento-p fw-500 text-center">
                            Reviewing the rules can help you be more successful
                            when posting incidents
                        </div>
                        <div className="rules-container">
                            {rules.map((r) => (
                                <RuleItem
                                    item={r}
                                    openRule={openRule}
                                    close={setNRules}
                                    key={r.question}
                                />
                            ))}
                        </div>
                    </div>

                    <div className="card-footer d-flex flex-j-end">
                        <div className="button-wrap">
                            <Button
                                text="close"
                                className="close-modal"
                                handleClick={() => setOpen(false)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RulesModel;
